import { BaseService } from "mrb/core";
import { AppHomeSectionApiRouteService } from "common/services";

class AppHomeSectionService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new AppHomeSectionApiRouteService());
    }

    getAll(options, abortSignal = null) {
        const url = this.routeService.getAll(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    getFeaturedGrid(options, abortSignal = null) {
        const url = this.routeService.getFeaturedGrid(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    getFeaturedPages(options, abortSignal = null) {
        const url = this.routeService.getFeaturedPages(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    createFeaturedPage(systemType, abortSignal = null) {
        const url = this.routeService.createFeaturedPage(systemType);
        return this.apiClient.post(url, null, null, abortSignal);
    }

    deleteFeaturedPage(pageId, abortSignal = null) {
        const url = this.routeService.deleteFeaturedPage(pageId);
        return this.apiClient.delete(url, null, null, abortSignal);
    }

    updateFeaturedPageGrid(pageId, resource, abortSignal = null) {
        const url = this.routeService.updateFeaturedPageGrid(pageId, resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    getContent(options, abortSignal = null) {
        const url = this.routeService.getContent(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    update(systemType, resource, abortSignal = null) {
        const url = this.routeService.update(systemType, resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    updateFeaturedGrid(systemType, resource, abortSignal = null) {
        const url = this.routeService.updateFeaturedGrid(systemType, resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }
}

export default AppHomeSectionService;
